import { isEmpty } from '@/utils/index.js'
function createtransitionenService (bindElement, startPositionX = '0', startPositionY = '0', playTime = '1s', animationType = 'ease') {
  if (!bindElement) {
    return
  }

  bindElement.getBoundingClientRect()

  bindElement.style.transform = `translate(${startPositionX},${startPositionY})`
  bindElement.style.opacity = 0

  // 返回播放函数
  return [
    bindElement,
    () => {
      bindElement.getBoundingClientRect()
      bindElement.style.transition = `all ${playTime} ${animationType}`
      bindElement.style.transform = `translate(0)`
      bindElement.style.opacity = 1
      bindElement.addEventListener('transitionend', () => {
        bindElement.style.transition = ''
        bindElement.style.transform = ''
      })
    }
  ]
}

const elMap = new WeakMap()

const ob = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const {play, waitTime} = elMap.get(entry.target)
      if (!play || typeof play !== 'function') {
        ob.unobserve(entry.target)
        return
      }
      setTimeout(() => {
        play()
      }, waitTime * 1000)
      ob.unobserve(entry.target)
    }
  })
},
{
  root: null,
  rootMargin: '0px',
  threshold: 0
}
)

export default {
  bind (el, binding, component) {
    const playInfo = {
      startPosition: binding.value || '-100px',
      // 方向
      direction: binding.modifiers.vertical ? 'vertical' : 'horizontal'
    }
    let x = '0'
    let y = '0'
    if (playInfo.direction === 'horizontal') {
      x = playInfo.startPosition
    } else {
      y = playInfo.startPosition
    }
    setTimeout(() => {
      let waitTime = 0
      let playTime = '.5s'
      let animationType = 'ease-out'
      if (component.data.attrs) {
        if (!isEmpty(component.data.attrs['system-first-in-move-wait'])) {
          waitTime = component.data.attrs['system-first-in-move-wait']
        }

        if (!isEmpty(component.data.attrs['system-first-in-move-play-time'])) {
          playTime = component.data.attrs['system-first-in-move-play-time']
        }

        if (!isEmpty(component.data.attrs['system-first-in-move-animation-type'])) {
          animationType = component.data.attrs['system-first-in-move-animation-type']
        }
      }

      const [observeDom, play] = createtransitionenService(el, x, y, playTime, animationType)
      ob.observe(observeDom)

      elMap.set(observeDom, {
        play,
        waitTime
      })
    })
  },
  unbind (el) {
    ob.unobserve(el)
    elMap.delete(el)
  }
}



// WEBPACK FOOTER //
// ./src/directive/firstInViewPort/move.js